var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8141 13.0569C12.718 13.1295 12.5999 13.167 12.4794 13.167H0.5C0.223858 13.167 0 12.9431 0 12.667C0 12.3909 0.223858 12.167 0.5 12.167H12.4725C12.9775 12.167 13.2172 12.7528 12.8141 13.0569ZM16 6.66701C16 6.94816 15.7655 7.16699 15.4843 7.16699H0.5C0.223857 7.16699 0 6.94313 0 6.66699C0 6.39085 0.223858 6.16699 0.5 6.16699H15.4843C15.7655 6.16699 16 6.38582 16 6.66698V6.66701ZM12.8141 0.27705C13.2172 0.581205 12.9775 1.16699 12.4725 1.16699H0.5C0.223858 1.16699 0 0.943135 0 0.666992C0 0.39085 0.223858 0.166992 0.5 0.166992H12.4794C12.5999 0.166992 12.718 0.204474 12.8141 0.27705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.07b392345f0b17865bee7fb549125aa1.svg";
export { ForwardRef as ReactComponent };